/** @typedef {{ analytics: boolean, marketing: boolean, decided: boolean }} StoreConsentState */

const CONSENT_KEY_PREFIX = 'ominia.consent.v2.';

/** @param {string} slug */
export function consentStorageKey(slug) {
  return `${CONSENT_KEY_PREFIX}${slug}`;
}

/** @param {string} slug */
export function readStoreConsent(slug) {
  if (!slug || typeof window === 'undefined') {
    return /** @type {StoreConsentState} */ ({ analytics: false, marketing: false, decided: false });
  }
  try {
    const raw = window.localStorage.getItem(consentStorageKey(slug));
    if (!raw) return { analytics: false, marketing: false, decided: false };
    const o = JSON.parse(raw);
    if (!o || typeof o !== 'object') return { analytics: false, marketing: false, decided: false };
    return {
      analytics: o.analytics === true,
      marketing: o.marketing === true,
      decided: o.decided === true,
    };
  } catch {
    return { analytics: false, marketing: false, decided: false };
  }
}

/**
 * @param {string} slug
 * @param {{ analytics: boolean, marketing: boolean }} choice
 */
export function writeStoreConsent(slug, choice) {
  if (!slug || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      consentStorageKey(slug),
      JSON.stringify({
        analytics: Boolean(choice.analytics),
        marketing: Boolean(choice.marketing),
        decided: true,
        at: new Date().toISOString(),
      }),
    );
  } catch {
    /* ignore quota */
  }
}
